import React from 'react';
import PropTypes from 'prop-types';
import { SingleQuestionController } from '@sm/question-widgets/respondent-quiz-results';
import PageHeader from '~app/components/Survey/PageHeader';
import './survey-page.scss';

const SurveyPage = props => {
  const { page, totalPages, pageIndex, survey } = props;

  const getPageQuestions = questions => {
    return (
      <>
        {questions?.map(item => {
          const { question } = item;
          const absoluteQuestionNumber = page.firstQuestionNumber + question.position.inPage - 1;
          question.position.inPage = absoluteQuestionNumber;
          question.position.label = `${absoluteQuestionNumber}`;
          return (
            <div className="sm-survey-page--question" key={question.id}>
              <SingleQuestionController question={question} />
            </div>
          );
        })}
      </>
    );
  };

  return (
    <section className="sm-survey-page--container" data-testid="SurveyPage__Container">
      <PageHeader currentPage={pageIndex + 1} totalPages={totalPages} />

      {getPageQuestions(survey[page.id])}
    </section>
  );
};

SurveyPage.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.string,
    firstQuestionNumber: PropTypes.number,
  }),
  survey: PropTypes.shape({
    enableNumbering: PropTypes.bool,
  }),
  pageIndex: PropTypes.number,
  totalPages: PropTypes.number,
};

SurveyPage.defaultProps = {
  page: null,
  survey: null,
  pageIndex: undefined,
  totalPages: undefined,
};

export default SurveyPage;
